export default __webpack_public_path__ + "static/media/gallery-wip-blade plug_03.76b165c0.jpg";